import appConfigCoverGoDev from "./appConfigCoverGoDev.js"
import { COVERGO_ASIA_PRE_PROD } from "../consts.js"

export const boclife = {
	"boclife-uat-studio.quote.hk": { appConfig: appConfigCoverGoDev, envConfig: COVERGO_ASIA_PRE_PROD }
}
